import axios from 'axios';
import moment from 'moment';

import { API_HOST } from '../../constans/api';

export const SET_USER_ID_VK = 'SET_USER_ID_VK';
export const SET_ACTIVE_MODAL_VK = 'SET_ACTIVE_MODAL_VK';
export const SET_ACTIVE_PANEL_VK = 'SET_ACTIVE_PANEL_VK';
export const CHANGE_FIELD_MODAL_VK = 'CHANGE_FIELD_MODAL_VK';
export const REQUEST_SEND_FAST_WRITE_VK = 'REQUEST_SEND_FAST_WRITE_VK';
export const RESPONSE_SEND_FAST_WRITE_VK = 'RESPONSE_SEND_FAST_WRITE_VK';
export const REQUEST_GET_USER_VK = 'REQUEST_GET_USER_VK';
export const RESPONSE_GET_USER_VK = 'RESPONSE_GET_USER_VK';
export const RESPONSE_ADD_USER_PHONE_VK = 'RESPONSE_ADD_USER_PHONE_VK';
export const ADD_USER_VK = 'ADD_USER_VK';

export const setVKPhoneAction = (phone, userID, url) => (dispatch) => {
    const formData = new FormData();
    formData.append('phone', phone);
    formData.append('vkid', userID);
    formData.append('url', url);
    formData.append('token', window.vpriemScheduleParams.token);

    axios.post(`${API_HOST}vk/addPhone`, formData)
    .then((response) => {
        if (!response.data.error) {
            dispatch({ type: RESPONSE_ADD_USER_PHONE_VK, payload: phone });
        } else {
            dispatch({ type: RESPONSE_ADD_USER_PHONE_VK, payload: null });
        }
    })
    .catch((e) => {
        console.error(e);
    });
};

export const getVKUserAction = (userID, url) => (dispatch) => {
    dispatch({ type: REQUEST_GET_USER_VK });

    axios.get(`${API_HOST}vk/getUser/${userID}?url=${btoa(url)}&token=${window.vpriemScheduleParams.token}`)
    .then((response) => {
        if (!response.data.error) {
            dispatch({ type: RESPONSE_GET_USER_VK, payload: response.data.data[0] });
        } else {
            dispatch({ type: RESPONSE_GET_USER_VK, payload: null });
        }
    })
    .catch((e) => {
        console.error(e);
    });
};

export const addVKUserAction = (data, url) => (dispatch) => {
    let birthday = null;
    const newData = data;
    if (Object.prototype.hasOwnProperty.call(data, 'bdate')) {
        const parseBDate = data.bdate.split('.');
        if (parseBDate.length === 2) {
            birthday = moment(`${moment().year()}-${+parseBDate[1] < 10 ? `0${parseBDate[1]}` : parseBDate[1]}-${+parseBDate[0] < 10 ? `0${parseBDate[0]}` : parseBDate[0]}`);
        } else if (parseBDate.length === 3) {
            birthday = moment(`${parseBDate[2]}-${+parseBDate[1] < 10 ? `0${parseBDate[1]}` : parseBDate[1]}-${+parseBDate[0] < 10 ? `0${parseBDate[0]}` : parseBDate[0]}`);
        }
        newData.bdate = birthday.format('YYYY-MM-DD');
    }

    dispatch({ type: ADD_USER_VK, payload: newData });

    const formData = new FormData();
    formData.append('vkid', data.id);
    formData.append('firstName', data.first_name);
    formData.append('lastName', data.last_name);
    if (birthday) {
        formData.append('birthday', birthday.format('YYYY-MM-DD'));
    }
    formData.append('url', url);
    formData.append('token', window.vpriemScheduleParams.token);

    axios.post(`${API_HOST}vk/addUser`, formData)
    .catch((e) => {
        console.error(e);
    });
};

export const setVKUserIDAction = vkID => (dispatch) => {
    dispatch({ type: SET_USER_ID_VK, payload: vkID });
};

export const setActiveModalVKAction = modalID => (dispatch) => {
    dispatch({ type: SET_ACTIVE_MODAL_VK, payload: modalID });
};

export const setActivePanelVKAction = (panelID) => (dispatch) => {
    dispatch({ type: SET_ACTIVE_PANEL_VK, payload: panelID });
};

export const changeFieldModalVKAction = (property, value) => (dispatch) => {
    dispatch({ type: CHANGE_FIELD_MODAL_VK, payload: { property, value } });
};

export const sendFastWriteAction = data => (dispatch) => {
    dispatch({ type: REQUEST_SEND_FAST_WRITE_VK });

    const formData = new FormData();
    formData.append('phone', data.phone);
    formData.append('date', data.date);
    formData.append('token', window.vpriemScheduleParams.token);

    axios.post(`${API_HOST}writes/sendFastWrite`, formData)
    .then((response) => {
        dispatch(setActiveModalVKAction(null));
        if (!response.data.error) {
            dispatch(setActivePanelVKAction('successPanel'));
        } else {
            dispatch(setActivePanelVKAction('errorPanel'));
        }
    })
    .catch(() => {
        dispatch(setActiveModalVKAction(null));
        dispatch(setActivePanelVKAction('errorPanel'));
    });
};
